var Backbone, SupportBaseTicketModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

SupportBaseTicketModel = (function(superClass) {
  extend(SupportBaseTicketModel, superClass);

  function SupportBaseTicketModel() {
    return SupportBaseTicketModel.__super__.constructor.apply(this, arguments);
  }

  SupportBaseTicketModel.prototype.initialize = function() {
    return this.setReasonText();
  };

  SupportBaseTicketModel.prototype.setReasonText = function() {
    var SubCategory, category;
    category = Groupon.Support.ContentModel.getCategory();
    SubCategory = Groupon.Support.ContentModel.getSubCategory();
    if ((category != null) && (SubCategory != null)) {
      this.reasonId = SubCategory.id;
      this.reasonText = SubCategory.text;
      this.reasonGroup = SubCategory.group;
      this.parentCategoryId = category.id;
      this.parentCategoryText = category.text;
      return this.isDummyCategory = false;
    } else {
      if (window.isCostcoDeal()) {
        this.reasonId = "costco_faq";
        this.reasonText = I18n.translate('js.modules.support.costco_faq');
        this.parentCategoryId = "costco_faq";
        this.parentCategoryText = I18n.translate('js.modules.support.costco_faq');
      } else {
        this.reasonId = "direct_email_ticket_subcategory";
        this.reasonText = I18n.translate('js.modules.support.default_reason');
        this.parentCategoryId = "direct_email_ticket";
        this.parentCategoryText = I18n.translate('js.modules.support.default_parent_category');
      }
      return this.isDummyCategory = true;
    }
  };

  SupportBaseTicketModel.prototype.populateOrderListInfo = function(emailBasicData) {
    if ((window.currentUser != null) && Groupon.Support.currentOrdersFilter.isOrdersInfoValid()) {
      return emailBasicData.orderListInfo = {
        hasOrders: Groupon.Support.OrdersCollection.hasOrders(),
        hasSingleOrder: Groupon.Support.OrdersCollection.getNumberOfOrdersFetched() === 1
      };
    }
  };

  SupportBaseTicketModel.prototype.getBasicTicketData = function() {
    var currentUserFullName, emailBasicData;
    currentUserFullName = window.getCurrentUserFullName();
    emailBasicData = {
      support_id: "",
      reason: this.reasonId,
      reason_text: this.reasonText,
      reason_group: this.reasonGroup,
      parent_category: this.parentCategoryId,
      parent_category_text: this.parentCategoryText,
      currentOrder: Groupon.Support.currentOrder,
      description: "",
      escalate_to_merchant: Groupon.Support.ContentModel.escalateToMerchant,
      is_refund_eligible: Groupon.Support.ContentModel.isRefundEligible,
      user_name: !_.isEmpty(currentUserFullName) ? currentUserFullName : void 0,
      user_email: typeof currentUser !== "undefined" && currentUser !== null ? currentUser.email : void 0
    };
    this.populateOrderListInfo(emailBasicData);
    return emailBasicData;
  };

  return SupportBaseTicketModel;

})(Backbone.Model);

module.exports = SupportBaseTicketModel;

//# sourceMappingURL=data:application/json;base64,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
